var Backbone, SupportBaseTicketModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportBaseTicketModel = (function(superClass) {
  extend(SupportBaseTicketModel, superClass);

  function SupportBaseTicketModel() {
    return SupportBaseTicketModel.__super__.constructor.apply(this, arguments);
  }

  SupportBaseTicketModel.prototype.initialize = function() {
    return this.setReasonText();
  };

  SupportBaseTicketModel.prototype.setReasonText = function() {
    var SubCategory, category;
    category = Groupon.Support.ContentModel.getCategory();
    SubCategory = Groupon.Support.ContentModel.getSubCategory();
    if ((category != null) && (SubCategory != null)) {
      this.reasonId = SubCategory.id;
      this.reasonText = SubCategory.text;
      this.reasonGroup = SubCategory.group;
      this.parentCategoryId = category.id;
      this.parentCategoryText = category.text;
      return this.isDummyCategory = false;
    } else {
      if (window.isCostcoDeal()) {
        this.reasonId = "costco_faq";
        this.reasonText = I18n.translate('js.modules.support.costco_faq');
        this.parentCategoryId = "costco_faq";
        this.parentCategoryText = I18n.translate('js.modules.support.costco_faq');
      } else {
        this.reasonId = "direct_email_ticket_subcategory";
        this.reasonText = I18n.translate('js.modules.support.default_reason');
        this.parentCategoryId = "direct_email_ticket";
        this.parentCategoryText = I18n.translate('js.modules.support.default_parent_category');
      }
      return this.isDummyCategory = true;
    }
  };

  SupportBaseTicketModel.prototype.populateOrderListInfo = function(emailBasicData) {
    if ((window.currentUser != null) && Groupon.Support.currentOrdersFilter.isOrdersInfoValid()) {
      return emailBasicData.orderListInfo = {
        hasOrders: Groupon.Support.OrdersCollection.hasOrders(),
        hasSingleOrder: Groupon.Support.OrdersCollection.getNumberOfOrdersFetched() === 1
      };
    }
  };

  SupportBaseTicketModel.prototype.getBasicTicketData = function() {
    var currentUserFullName, emailBasicData;
    currentUserFullName = window.getCurrentUserFullName();
    emailBasicData = {
      support_id: "",
      reason: this.reasonId,
      reason_text: this.reasonText,
      reason_group: this.reasonGroup,
      parent_category: this.parentCategoryId,
      parent_category_text: this.parentCategoryText,
      currentOrder: Groupon.Support.currentOrder,
      description: "",
      escalate_to_merchant: Groupon.Support.ContentModel.escalateToMerchant,
      is_refund_eligible: Groupon.Support.ContentModel.isRefundEligible,
      user_name: !_.isEmpty(currentUserFullName) ? currentUserFullName : void 0,
      user_email: typeof currentUser !== "undefined" && currentUser !== null ? currentUser.email : void 0
    };
    this.populateOrderListInfo(emailBasicData);
    return emailBasicData;
  };

  return SupportBaseTicketModel;

})(Backbone.Model);

module.exports = SupportBaseTicketModel;

//# sourceMappingURL=data:application/json;base64,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
